import TextBlock from '@/components/atoms/text-block/text-block';
import IRichText from '@into-discovery/browsewebshared/src/models/viewModels/base/IRichText';

type Props = {
  typicalCostsIntro: IRichText;
};

export default function TypicalCosts({ typicalCostsIntro }: Props) {
  return <TextBlock title="Typical costs" text={typicalCostsIntro} titleSize={3} />;
}
